import Vue from 'vue';

const state = {
	coreValues: [],
	coreValues_loading: false
};

const getters = {
	coreValues: state => {
		return state.coreValues;
	}
};

const actions = {
	get({ commit, rootState }) {
		console.log('Retrieving Core Values...');
		commit('GET_PENDING');
		return Vue.axios
			.get(`/api/${rootState.tenantId}/coreValues`)
			.then(response => {
				commit('GET_SUCCESS', response.data);
			})
			.catch(error => {
				commit('GET_FAILURE', error);
			});
	},
	reorder({ commit, rootState }, orderedIds) {
		console.log('Reordering Core Values...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.put(`/api/${rootState.tenantId}/coreValues/reorder`, { orderedIds })
				.then(resp => {
					commit('GET_SUCCESS', resp.data);
					resolve(resp.data);
				})
				.catch(err => {
					console.log('Error reordering Core Values');
					console.log(err);
					reject(err);
				});
		});
	},
	add({ commit, dispatch, rootState }, coreValue) {
		console.log('Adding New Core Value...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.post(`/api/${rootState.tenantId}/coreValues`, coreValue)
				.then(resp => {
					commit('ADD_SUCCESS', coreValue);
					dispatch('get');
					resolve(resp);
				})
				.catch(err => {
					console.log('Error saving Core Value');
					console.log(err);
					reject(err);
				});
		});
	},
	edit({ commit, dispatch, rootState }, coreValue) {
		console.log('Updating Core Value...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.put(`/api/${rootState.tenantId}/coreValues/${coreValue.id}`, coreValue)
				.then(resp => {
					commit('EDIT_SUCCESS', coreValue);
					dispatch('get');
					resolve(coreValue);
				})
				.catch(err => {
					console.log('Error updating Core Value');
					console.log(err);
					reject(err);
				});
		});
	},
	delete({ commit, dispatch, rootState }, coreValue) {
		console.log('Deleting Core Value...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.delete(`/api/${rootState.tenantId}/coreValues/${coreValue.id}`)
				.then(resp => {
					commit('DELETE_SUCCESS', coreValue);
					dispatch('get');
					resolve(true);
				})
				.catch(err => {
					console.log('Error deleting Core Value');
					console.log(err);
					reject(err);
				});
		});
	}
};

const mutations = {
	GET_PENDING(state) {
		state.coreValues_loading = true;
	},
	GET_SUCCESS(state, data) {
		state.coreValues_loading = false;
		state.coreValues = data;
	},
	GET_FAILURE(state, error) {
		state.coreValues_loading = false;
		console.log(error);
	},
	ADD_SUCCESS(state, data) {
		state.coreValues.push(data);
	},
	EDIT_SUCCESS(state, data) {
		const index = state.coreValues.findIndex(pr => pr.id === data.id);
		if (index > -1) {
			state.coreValues.splice(index, 1, data);
		}
	},
	DELETE_SUCCESS(state, data) {
		const index = state.coreValues.findIndex(coreValue => coreValue.id === data.id);
		if (index > -1) {
			state.coreValues.splice(index, 1);
		}
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
